import { getters } from "@shared/template/StoreTemplates/FilterStoreTemplate"
export default {
  ...getters
}
